// Camp Mode — Travel Sleeper interactive features
// Handles: day/night toggle, hotspot tooltips, timeline scroll, pressure dial
(function () {
  'use strict';

  /* --------------------------------------------------
     Day/Night Toggle
     -------------------------------------------------- */
  function initToggle() {
    var toggle = document.querySelector('[data-camp-toggle]');
    if (!toggle) return;

    var hero = toggle.closest('.camp-mode');
    if (!hero) return;

    var label = toggle.querySelector('[data-camp-toggle-label]');
    var icon = toggle.querySelector('.camp-mode__toggle-icon');

    // Restore from sessionStorage
    var stored = sessionStorage.getItem('camp_mode_theme');
    if (stored === 'day') {
      if (label) label.textContent = 'Night Mode';
      updateSections('day');
    }

    toggle.addEventListener('click', function () {
      var isNight = hero.classList.contains('camp-mode--night');

      if (isNight) {
        hero.classList.remove('camp-mode--night');
        hero.classList.add('camp-mode--day');
        if (label) label.textContent = 'Night Mode';
        sessionStorage.setItem('camp_mode_theme', 'day');
        updateSections('day');
      } else {
        hero.classList.remove('camp-mode--day');
        hero.classList.add('camp-mode--night');
        if (label) label.textContent = 'Day Mode';
        sessionStorage.setItem('camp_mode_theme', 'night');
        updateSections('night');
      }

      // Animate icon
      if (icon) {
        icon.style.transform = 'rotate(180deg)';
        setTimeout(function () { icon.style.transform = ''; }, 300);
      }
    });
  }

  // Propagate day/night to all camp-mode elements on the page
  function updateSections(mode) {
    var campElements = document.querySelectorAll('.camp-mode');
    campElements.forEach(function (el) {
      if (mode === 'day') {
        el.classList.add('camp-mode--day');
        el.classList.remove('camp-mode--night');
      } else {
        el.classList.add('camp-mode--night');
        el.classList.remove('camp-mode--day');
      }
    });
  }

  /* --------------------------------------------------
     Hotspot Tooltips — click to toggle
     -------------------------------------------------- */
  function initHotspots() {
    var hotspots = document.querySelectorAll('[data-camp-hotspot]');
    if (!hotspots.length) return;

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasActive = hotspot.classList.contains('is-active');

        // Close all
        hotspots.forEach(function (h) { h.classList.remove('is-active'); });

        // Toggle clicked
        if (!wasActive) {
          hotspot.classList.add('is-active');
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function () {
      hotspots.forEach(function (h) { h.classList.remove('is-active'); });
    });

    // Close on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hotspots.forEach(function (h) { h.classList.remove('is-active'); });
      }
    });
  }

  /* --------------------------------------------------
     Joke Banner — pop-in animation
     -------------------------------------------------- */
  function initJokeBanner() {
    var joke = document.querySelector('[data-camp-joke]');
    if (!joke) return;

    var punchline = joke.querySelector('[data-camp-punchline]');
    if (!punchline) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Delay the punchline reveal for comedic timing
          setTimeout(function () {
            punchline.classList.add('is-visible');
          }, 600);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(joke);
  }

  /* --------------------------------------------------
     Timeline — scroll-triggered entrance animations
     -------------------------------------------------- */
  function initTimeline() {
    var steps = document.querySelectorAll('[data-camp-timeline-step]');
    if (!steps.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });

    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  /* --------------------------------------------------
     Comfort Tuning — preset + slider explainer
     -------------------------------------------------- */
  function initDial() {
    var container = document.querySelector('[data-camp-dial]');
    if (!container) return;

    var range = container.querySelector('[data-camp-dial-range]');
    var buttons = container.querySelectorAll('[data-camp-dial-step]');
    var labelEl = container.querySelector('[data-camp-dial-label]');
    var descriptionEl = container.querySelector('[data-camp-dial-description]');
    var foamEl = container.querySelector('[data-camp-dial-foam]');
    var airEl = container.querySelector('[data-camp-dial-air]');
    var useEl = container.querySelector('[data-camp-dial-use]');
    if (!range || !buttons.length) return;

    var presets = [
      {
        label: 'Cloud',
        description: 'Lighter air pressure with plenty of foam contour for side sleepers and anyone chasing the plush hotel-bed feel.',
        foam: 82,
        air: 34,
        use: 'Side sleepers'
      },
      {
        label: 'Balanced',
        description: 'Memory foam takes the pressure points, while a moderate air fill keeps your hips and shoulders level all night.',
        foam: 74,
        air: 56,
        use: 'Most sleepers'
      },
      {
        label: 'Supportive',
        description: 'More air under the foam adds structure without making the surface feel stiff or bouncy.',
        foam: 66,
        air: 74,
        use: 'Back sleepers'
      },
      {
        label: 'Firm',
        description: 'Maximum chamber pressure for drivers who want the flattest, most planted sleep surface Tesla camp mode can offer.',
        foam: 58,
        air: 92,
        use: 'Extra support'
      }
    ];

    function render(index) {
      var preset = presets[index];
      if (!preset) return;

      range.value = String(index);
      container.style.setProperty('--camp-dial-progress', String(index / (presets.length - 1)));
      container.style.setProperty('--camp-dial-progress-pct', ((index / (presets.length - 1)) * 100) + '%');
      container.style.setProperty('--camp-dial-foam-height', (26 + index * 4) + '%');
      container.style.setProperty('--camp-dial-air-height', (26 + index * 9) + '%');
      container.style.setProperty('--camp-dial-air-glow-height', (18 + index * 5) + '%');
      container.style.setProperty('--camp-dial-air-glow-bottom', (12 + index * 2) + '%');
      container.style.setProperty('--camp-dial-foam-glow-top', (18 - index) + '%');

      if (labelEl) labelEl.textContent = preset.label;
      if (descriptionEl) descriptionEl.textContent = preset.description;
      if (foamEl) foamEl.textContent = preset.foam + '%';
      if (airEl) airEl.textContent = preset.air + '%';
      if (useEl) useEl.textContent = preset.use;

      buttons.forEach(function (button, buttonIndex) {
        var isActive = buttonIndex === index;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        render(index);
      });
    });

    range.addEventListener('input', function () {
      render(parseInt(range.value, 10) || 0);
    });

    render(parseInt(range.value, 10) || 1);
  }

  /* --------------------------------------------------
     Parallax — subtle depth on camp scene
     Disabled on mobile (handled by CSS).
     -------------------------------------------------- */
  function initParallax() {
    var layers = document.querySelectorAll('.camp-parallax-bg, .camp-parallax-mid, .camp-parallax-fg');
    if (!layers.length) return;
    if (window.innerWidth <= 768) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          layers.forEach(function (layer) {
            var speed = parseFloat(layer.dataset.parallaxSpeed) || 0.1;
            var rect = layer.getBoundingClientRect();
            var offset = (rect.top + scrollY) * speed;
            layer.style.transform = 'translateY(' + (scrollY * speed - offset) + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* --------------------------------------------------
     Init all Camp Mode features on DOM ready
     -------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initToggle();
    initHotspots();
    initJokeBanner();
    initTimeline();
    initDial();
    initParallax();
  });
})();
